export default __webpack_public_path__ + "static/tb_radler_02-cb74b6aa10c37e2b27c252442a67a591.svg";